import { createI18n }  from "vue-i18n";
import zh_hant_messages from "@/lang/zh_hant";
import zh_hans_messages from "@/lang/zh_hans";
import en_messages from "@/lang/en";


 const i18n = createI18n({
  globalInjection: true,
  allowComposition: true,
  warnHtmlMessage: false,
  legacy: false,
  locale: "zh_hant",
  fallbackLocale: "zh_hant",
  messages: {
    zh_hant: zh_hant_messages,
    zh_hans: zh_hans_messages,
    en: en_messages,
  },
});

export default i18n;
